import { bus, helper } from '@/utils'

export default {
  name: 'FirmwareDelete',
  beforeDestroy () {
    bus.$off('show-delete-firmware')
  },
  computed: {
    version () {
      return this.firmware.version
    }
  },
  methods: {
    closePopup () {
      this.showModal = false
    },
    async deleteFirmware (id) {
      const data = `id=${id}`
      return await this.$api.removeFirmware(data)
        .then(() => bus.$emit('get-firmware-list'))
        .then(() => this.closePopup())
        .then(() => this.$message({
          message: this.$t('messageFirmwareDelete'),
          showClose: true,
          type: 'success'
        }))
        .catch((error) => helper.showErrorMessage(this, this.component, error))
    }
  },
  data () {
    return {
      buttons: [
        {
          id: 'Close',
          class: 'btn-close',
          text: 'firmwareDeleteDialogButtonCloseText',
          type: 'text',
          click: () => { this.closePopup() }
        },
        {
          id: 'Delete',
          text: 'firmwareDeleteDialogButtonDeleteText',
          type: 'warning',
          click: () => { this.deleteFirmware(this.firmware.name) }
        }
      ],
      component: 'firmwareDelete',
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      firmware: {},
      showModal: false
    }
  },
  mounted () {
    bus.$on('show-delete-firmware', ({ show, info }) => {
      if (show) {
        this.showModal = true
      }

      if (info) {
        this.firmware = info
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/FirmwareDelete/FirmwareDelete.js